import { useEffect, useRef } from "react"

export const useClickOutside = (ref, handler) => {
  const handlerRef = useRef(handler)
  handlerRef.current = handler

  useEffect(() => {
    const listener = (event) => {
      const el = ref.current
      if (!el) return

      const path = typeof event.composedPath === "function" ? event.composedPath() : []
      const isInside = path.length > 0 ? path.includes(el) : el.contains(event.target)

      if (!isInside) handlerRef.current(event)
    }

    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)
    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
    }
  }, [ref])
}

export default useClickOutside
